import { Routes } from '@angular/router';
import { authGuard, guestGuard } from './core/guards/auth.guard';
import { AdminShellComponent } from './layout/admin-shell/admin-shell.component';
import { LoginComponent } from './features/auth/login/login.component';
import { VerifyOtpComponent } from './features/auth/verify-otp/verify-otp.component';
import { DashboardComponent } from './features/dashboard/dashboard.component';
import { UsersListComponent } from './features/users/users-list/users-list.component';
import { UserDetailComponent } from './features/users/user-detail/user-detail.component';
import { RentPaymentsComponent } from './features/rent-payments/rent-payments.component';
import { TransactionsComponent } from './features/transactions/transactions.component';
import { TransactionDetailComponent } from './features/transactions/transaction-detail.component';
import { CardProgramsComponent } from './features/card-programs/card-programs.component';
import { KobbleComponent } from './features/kobble/kobble.component';
import { SettingsComponent } from './features/settings/settings.component';
import { NotificationsComponent } from './features/notifications/notifications.component';
import { SendNotificationComponent } from './features/notifications/send-notification/send-notification.component';
import { SubscriptionsComponent } from './features/subscriptions/subscriptions.component';
import { PointsComponent } from './features/points/points.component';
import { TilloBrandsComponent } from './features/tillo-brands/tillo-brands.component';
import { ShoppingPartnerCategoriesComponent } from './features/shopping-partner-categories/shopping-partner-categories.component';
import { ShoppingPartnersComponent } from './features/shopping-partners/shopping-partners.component';
import { ShoppingPartnerRewardsComponent } from './features/shopping-partner-rewards/shopping-partner-rewards.component';
import { AgenciesComponent } from './features/agencies/agencies.component';
import { MediaLibraryComponent } from './features/media-library/media-library.component';
import { WebhookLogsComponent } from './features/webhook-logs/webhook-logs.component';
import { WebhookLogDetailComponent } from './features/webhook-logs/webhook-log-detail.component';
import { SupportTicketsComponent } from './features/support-tickets/support-tickets.component';
import { SupportTicketDetailComponent } from './features/support-tickets/support-ticket-detail.component';

export const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'dashboard' },
  { path: 'login', component: LoginComponent, canActivate: [guestGuard] },
  { path: 'verify-otp', component: VerifyOtpComponent, canActivate: [guestGuard] },
  {
    path: '',
    component: AdminShellComponent,
    canActivate: [authGuard],
    children: [
      { path: 'dashboard', component: DashboardComponent },
      { path: 'users', component: UsersListComponent },
      { path: 'users/:id', component: UserDetailComponent },
      { path: 'rent-payments', component: RentPaymentsComponent },
      { path: 'transactions', component: TransactionsComponent },
      { path: 'transactions/:id', component: TransactionDetailComponent },
      { path: 'points', component: PointsComponent },
      { path: 'tillo-brands', component: TilloBrandsComponent },
      { path: 'shopping-partner-categories', component: ShoppingPartnerCategoriesComponent },
      { path: 'shopping-partners', component: ShoppingPartnersComponent },
      { path: 'shopping-partner-rewards', component: ShoppingPartnerRewardsComponent },
      { path: 'agencies', component: AgenciesComponent },
      { path: 'media-library', component: MediaLibraryComponent },
      { path: 'notifications/send', component: SendNotificationComponent },
      { path: 'notifications', component: NotificationsComponent },
      { path: 'card-programs', component: CardProgramsComponent },
      { path: 'subscriptions', component: SubscriptionsComponent },
      { path: 'webhook-logs', component: WebhookLogsComponent },
      { path: 'webhook-logs/:provider/:id', component: WebhookLogDetailComponent },
      { path: 'support-tickets', component: SupportTicketsComponent },
      { path: 'support-tickets/:id', component: SupportTicketDetailComponent },
      { path: 'kobble', component: KobbleComponent },
      { path: 'settings', component: SettingsComponent },
    ],
  },
  { path: '**', redirectTo: 'dashboard' },
];
